<template>
    <div class="w-full">
            <div class="w-full md:w-3/4 mx-auto">
                <div class="w-full mt-5">
                    <h1 class="text-center font-bold text-2xl">PENDAFTARAN BOOKING BERHASIL</h1>
                </div>
                <div class="w-full mt-5">
                    <BuktiCard
                        :antrian="antrian"
                    />
                    <div class="w-full flex mt-5">
                        <a target="_blank" class="btn-secondary mr-2" :href="pdfLink">SIMPAN PDF</a>
                        <!-- <a target="_blank" class="btn-secondary self-end ml-auto" :href="antrian.QRCodeLink">DOWNLOAD QRCODE</a> -->
                        <a target="_blank" class="btn-secondary self-end ml-auto" :href="qrLink">SIMPAN QRCODE</a>
                    </div>
                    <div class="w-full mt-5 text-center">
                        <h1>SIMPAN DATA INI UNTUK MELAKUKAN SEP DI ANJUNGAN MANDIRI, DATANG KE RSUD 30 MENIT SEBELUM JAM PRAKTEK DOKTER</h1>
                    </div>
                    <div class="w-full mt-5">
                        <Link href="/" class="btn-primary mx-auto">SELESAI</Link>
                    </div>
                </div>
            </div>
        </div>
</template>


<script>
import { Link } from '@inertiajs/inertia-vue3'
import LayoutNoHeader from '../Shared/LayoutNoHeader.vue'
import BuktiCard from '../Shared/BuktiCard.vue'
export default{
    components: {
        Link,
        BuktiCard
    },
    props: {
        antrian: Object,
        pdfLink: String,
        qrLink: String
    },  
    layout: LayoutNoHeader
}
</script>